import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import { Popover } from "@mui/material";
import {
  AppCheckbox,
  DeleteButton,
  fontFamily,
  paddingAndMargin,
  screenHeaderStyle,
  UpperLowerText,
  useSharedValue,
  paginationstyle,
} from "../Constants/constants";
import {
  ConditionalPagination,
  paginationStyles,
  useDynamicRowsPerPage,
} from "../../utils/paginationUtils";
import { businessunitName } from "../../App_Settings/app_settings";
import { useHistory } from "react-router-dom";
import SearchInput from "../Constants/search_input";
import { handleFileDelete } from "../../services/deleteService";
import { updateFileData } from "../../services/fileDataService";
import DeleteModal from "../Models/Delete/DeleteModal";
import CircularProgress from "@mui/material/CircularProgress";
import { formatDate, getAllFilesList } from "../../Utility/utility";
import Loader from "../../Utility/loading";
import "../App.css";
import editIcon from "../../assets/new icons/rejections/note.svg";
import "../../App.css";

//
export default function RejectionsFunction() {
  const { isMenuOpen } = useSharedValue();
  const { drawerwidth, updateDrawerWidth } = useSharedValue();
  // const { searchValue } = useSharedValue();
  const [searchValue, setSearchValue] = useState("");
  const [extractedData, setExtractedData] = useState(null);

  const { defaultBusinessunit, defaultOrganization, defaultUser, formatBusinessUnitLabel } =
    useSharedValue();
  const [loading, setLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const history = useHistory();

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectDeletedItem, setSelectDeletedItem] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isReturningToQueue, setIsReturningToQueue] = useState(false);

  const { numberOfSelectedRows, updateRowNumberOfPages } = useSharedValue();
  const [startIndex, setStartIndex] = useState(0); // Initial rows per page value
  const [currentPage, setCurrentPage] = useState(1); // Current page number
  const { ref: scrollContainerRef, rowsPerPage: dynamicRowsPerPage } = useDynamicRowsPerPage();
  const [endIndex, setEndIndex] = useState(dynamicRowsPerPage);

  const columns = [
    { field: "fileName", headerName: "FILE NAME", type: "string" },
    // { field: 'entityUniqueIdentifier', headerName: 'UID', type: 'string', },
    { field: "businessUnit", headerName: businessunitName, type: "string" },
    { field: "rejectedBy", headerName: "REJECTED BY", type: "string" },
    { field: "rejectedDate", headerName: "REJECTED DATE", type: "string" },
    { field: "rejectionReason", headerName: "REASON", type: "string" },
    { field: "review", headerName: "REVIEW", type: "string" },
    { field: "notes", headerName: "NOTE", type: "string" },
    { field: "returnToQueue", headerName: "Return File", type: "string" },
    { field: "functions", headerName: "", type: "string" },
  ];
  const [rows, setRows] = React.useState([]);
  const [popoverAnchorEl, setPopoverAnchorEl] = React.useState(null);
  const [notes, setNotes] = useState(null);
  const [popoverRow, setPopoverRow] = useState(null);

  const handleClose = () => {
    setPopoverAnchorEl(null);
  };

  const open = Boolean(popoverAnchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleSaveClick = async () => {
    if (selectedFiles.length === 0) {
      alert("Please select files to return to processing queue.");
      return;
    }

    setIsReturningToQueue(true);

    try {
      await Promise.all(
        selectedFiles.map(async (fileId) => {
          const row = rows.find((r) => r.fileImportId === fileId);
          if (!row) return;
          const updatedRowData = {
            ...row,
            isProcessed: false,
            status: 1,
            reviewedDate: null,
            rejectionReason: null,
            rejectedBy: null,
            rejectedDate: null,
            notes: null,
            dataExtraction: null,
            dataVisualisation: null,
            dataValidation: null,
            accuracyPercentage: null,
          };
          await updateFileData(updatedRowData);
        })
      );

      setRows((prevRows) => prevRows.filter((row) => !selectedFiles.includes(row.fileImportId)));
      setSelectedFiles([]);

      alert(`${selectedFiles.length} file(s) returned to processing queue successfully!`);
    } catch (error) {
      console.error("Error returning files to queue:", error);
      alert("Failed to return some files to processing queue. Please try again.");
    } finally {
      setIsReturningToQueue(false);
    }
  };

  useEffect(() => {
    // setLoading(true);

    getAllFiles();
  }, [searchValue, defaultBusinessunit, defaultOrganization, defaultUser]);
  const getAllFiles = async () => {
    setLoading(true);
    const data = await getAllFilesList(
      history,
      defaultOrganization,
      defaultBusinessunit,
      defaultUser,
      4 // Status 4: Rejected
    );

    setRows(
      data.filter(
        (row) =>
          row.rejectedBy !== null &&
          (row.fileName.toLowerCase().includes(searchValue.toLowerCase()) ||
            (row.uploadedBy || "").toLowerCase().includes(searchValue.toLowerCase()))
      )
    );
    setLoading(false);
  };

  React.useEffect(() => {
    const items = JSON.parse(localStorage.getItem("ExtractedData"));
    if (items) {
      setExtractedData(items);
    }
  }, []);

  useEffect(() => {
    setCurrentPage(1);
    setStartIndex(0);
    setEndIndex(dynamicRowsPerPage);
  }, [dynamicRowsPerPage]);

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setStartIndex((parseInt(newPage) - 1) * dynamicRowsPerPage);
    setEndIndex((parseInt(newPage) - 1) * dynamicRowsPerPage + dynamicRowsPerPage);
    // Clear selections when changing pages
    setSelectedFiles([]);
  };

  let totalPages = Math.ceil(
    rows.filter((item) => item.rejectedBy !== null).length / dynamicRowsPerPage
  );

  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = parseInt(event.target.value);
    // updateRowNumberOfPages(newRowsPerPage);
    setRowsPerPage(newRowsPerPage);
    setStartIndex(0);
    setCurrentPage(1);
    setEndIndex(newRowsPerPage);
    // Clear selections when changing page size
    setSelectedFiles([]);
  };

  const handleReviewClick = (id, rowItem) => {
    history.push({
      pathname: "/displayExtractionView",
      state: {
        someValue: id,
        accuracyPercentage: rowItem.accuracyPercentage,
        datatable: rowItem.dataExtraction,
        dataTree: rowItem.dataVisualisation,
        row: rowItem,
        rootValue: "/rejections",
        iSEdit: true,
      },
    });
  };

  const handleReturnToQueue = async (row) => {
    setIsReturningToQueue(true);

    try {
      const updatedRowData = {
        ...row,
        isProcessed: false,
        status: 1,
        reviewedDate: null,
        rejectionReason: null,
        rejectedBy: null,
        rejectedDate: null,
        notes: null,
        dataExtraction: null,
        dataVisualisation: null,
        dataValidation: null,
        accuracyPercentage: null,
      };
      await updateFileData(updatedRowData);

      setRows((prevRows) => prevRows.filter((r) => r.fileImportId !== row.fileImportId));
      alert("File returned to processing queue successfully!");
    } catch (error) {
      console.error("Error returning file to queue:", error);
      alert("Failed to return file to processing queue. Please try again.");
    } finally {
      setIsReturningToQueue(false);
    }
  };

  const handleSelection = (isChecked, fileImportId) => {
    if (isChecked) {
      setSelectedFiles((prev) => [...prev, fileImportId]);
    } else {
      setSelectedFiles((prev) => prev.filter((id) => id !== fileImportId));
    }
  };

  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      // Select all rejected rows across all pages of the current search-filtered list
      const visibleFiles = rows
        .filter((item) => item.rejectedBy !== null)
        .map((row) => row.fileImportId);

      if (visibleFiles.length === 0) return;

      const confirmed = window.confirm(
        `Warning: You have selected all files for this action. This includes the files on every page. Do you want to continue?`
      );
      if (!confirmed) return;

      setSelectedFiles(visibleFiles);
    } else {
      setSelectedFiles([]);
    }
  };

  // Use centralized delete service
  const handleDelete = async () => {
    if (!selectDeletedItem) {
      alert("No file selected for deletion.");
      return;
    }

    const rowToDelete = rows.find((row) => row.fileImportId === selectDeletedItem);

    await handleFileDelete({
      fileImportId: selectDeletedItem,
      fileName: rowToDelete?.fileName || "Unknown file",
      rows,
      setIsDeleting,
      getAllFiles,

      setIsPopupOpen,
    });
  };

  return (
    <>
      <div className={screenHeaderStyle(isMenuOpen)}>
        {/* Loading overlay during deletion */}
        {(isDeleting || isReturningToQueue) && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.1)",
              zIndex: 999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                boxShadow: "none",
              }}
            >
              <CircularProgress size={24} style={{ color: "var(--loader-color)" }} />
              <span style={{ fontFamily: fontFamily, fontSize: "14px" }}>
                {isDeleting ? "Deleting file..." : "Returning files to processing queue..."}
              </span>
            </div>
          </div>
        )}

        {/* The div that fills the remaining height */}

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            marginBottom: paddingAndMargin.headerBelowHeight,
            marginTop: paddingAndMargin.headerTopHeight,
          }}
        >
          <SearchInput
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
            }}
            onClick={() => {
              setSearchValue("");
            }}
          />

          {/* Rows per page dropdown - next to search box */}
          {/* {rows.filter((item) => item.rejectedBy !== null).length > numberOfSelectedRows && (
          <div style={{ display: "flex", alignItems: "center", marginLeft: 10 }}>
            <label
              style={{
                fontFamily: fontFamily,
                fontWeight: 400,
                fontSize: 12,
                color: "#333",
              }}
            >
              Displayed per page:&nbsp;
              <select
                className="pagination-select"
                value={numberOfSelectedRows}
                onChange={handleRowsPerPageChange}
              >
                {[5, 10, 15, 20, 25, 30].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize}
                  </option>
                ))}
              </select>
            </label>
          </div>
        )} */}

          <div style={{ marginLeft: "auto" }}>
            {/* Adjusting button styles as per requirements */}
            {/* <Button variant="contained" onClick={handleDeleteList}>Delete</Button> */}
            <Button
              variant="contained"
              className="review-btn-filled"
              onClick={handleSaveClick}
              disabled={isReturningToQueue}
            >
              {isReturningToQueue
                ? "Processing..."
                : selectedFiles.length >= 1
                  ? `Return To File Import (${selectedFiles.length})`
                  : "Return To File Import"}
            </Button>
          </div>
        </div>

        {/* Displaying columns */}
        <div class="columntitlesRowStyle">
          <div>
            <AppCheckbox
              header
              onChange={(e) => handleSelectAll(e.target.checked)}
              checked={
                selectedFiles.length > 0 &&
                selectedFiles.length ===
                  rows
                    .filter((item) => item.rejectedBy !== null)
                    .sort((a, b) => new Date(b.rejectedDate) - new Date(a.rejectedDate))
                    .slice(startIndex, endIndex).length
              }
              indeterminate={
                selectedFiles.length > 0 &&
                selectedFiles.length <
                  rows
                    .filter((item) => item.rejectedBy !== null)
                    .sort((a, b) => new Date(b.rejectedDate) - new Date(a.rejectedDate))
                    .slice(startIndex, endIndex).length
              }
            />
          </div>
          {columns.map((column) => (
            <div key={column.field} className="columntitlesStyle">
              <UpperLowerText text={column.headerName} />
            </div>
          ))}
        </div>

        {/* Main container for table with fixed height */}
        <div style={{ height: "calc(100vh - 220px)", display: "flex", flexDirection: "column" }}>
          {/* Header row - fixed, no scrolling */}
          <div style={{ flexShrink: 0 }}>{/* Header content already rendered above */}</div>

          {/* Scrollable rows container */}
          <div ref={scrollContainerRef} style={{ flex: 1, overflowY: "auto" }}>
            {loading ? (
              <>
                {/* <CircularProgress /> */}
                <Loader />
              </>
            ) : rows.length === 0 ? (
              <div className="no-record">There are no records available.</div>
            ) : (
              <div>
                {rows
                  .filter((item) => item.rejectedBy !== null)
                  .sort((a, b) => new Date(b.rejectedDate) - new Date(a.rejectedDate)) // Sort by rejectedDate descending (latest first)
                  .slice(startIndex, endIndex)
                  .map((row, indexValue) => (
                    <div key={row.fileImportId} class="columnRowStyle">
                      <div>
                        <AppCheckbox
                          onChange={(event) =>
                            handleSelection(event.target.checked, row.fileImportId)
                          }
                          checked={selectedFiles.includes(row.fileImportId)}
                        />
                      </div>
                      {columns.map((column) => (
                        <div
                          key={column.field}
                          title={
                            column.headerName === "REJECTED DATE"
                              ? formatDate(row[column.field])
                              : column.field === "businessUnit" && formatBusinessUnitLabel
                                ? formatBusinessUnitLabel(row)
                                : row[column.field]
                          }
                          class="columnValuesStyle"
                          // style={columnValuesStyle}
                        >
                          {column.field === "review" &&
                            (() => {
                              const isReviewDisabled = row.uploadType >= 2 && row.uploadType <= 10;
                              return (
                                <div
                                  style={{
                                    cursor: isReviewDisabled ? "default" : "pointer",
                                    pointerEvents: isReviewDisabled ? "none" : "auto",
                                  }}
                                  onClick={
                                    isReviewDisabled
                                      ? undefined
                                      : () => handleReviewClick(row.fileImportId, row)
                                  }
                                >
                                  <span
                                    className={
                                      isReviewDisabled ? "action-link disabled" : "action-link"
                                    }
                                    style={{
                                      fontFamily: fontFamily,
                                      fontWeight: 300,
                                      fontSize: 14,
                                      textOverflow: "ellipsis",
                                      textTransform: "none",
                                    }}
                                  >
                                    Review
                                  </span>
                                </div>
                              );
                            })()}

                          {column.field === "returnToQueue" && (
                            <div
                              style={{ cursor: "pointer" }}
                              onClick={() => handleReturnToQueue(row)}
                            >
                              <span
                                className="action-link"
                                style={{
                                  fontFamily: fontFamily,
                                  fontWeight: 300,
                                  fontSize: 14,
                                  textOverflow: "ellipsis",
                                  width: "70px",
                                  display: "flex",
                                  justifyContent: "center",
                                  // marginLeft: 2,
                                  textTransform: "none",
                                }}
                              >
                                Return
                              </span>
                            </div>
                          )}

                          {column.field === "notes" ? (
                            <div>
                              <div style={{ display: "flex", justifyContent: "center", width: 30 }}>
                                <img
                                  title="Rejection Reason"
                                  style={{
                                    cursor: "pointer",
                                    filter: "var(--icon-download-filter)",
                                  }}
                                  onClick={(event) => {
                                    setNotes(row.notes);
                                    setPopoverRow(row);
                                    setPopoverAnchorEl(event.currentTarget);
                                  }}
                                  src={editIcon}
                                  alt="Edit"
                                />
                              </div>
                              <Popover
                                id={id}
                                open={open}
                                anchorEl={popoverAnchorEl}
                                onClose={handleClose}
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "center",
                                }}
                                transformOrigin={{
                                  vertical: "top",
                                  horizontal: "center",
                                }}
                                PaperProps={{
                                  style: {
                                    borderRadius: 10,
                                    boxShadow: "none",
                                    padding: "14px 16px",
                                    width: 460,
                                    maxWidth: "90vw",
                                  },
                                }}
                              >
                                <div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      marginBottom: 6,
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontWeight: 700,
                                        fontSize: 14,
                                        fontFamily: fontFamily,
                                        color: "#1a1a1a",
                                      }}
                                    >
                                      {popoverRow?.rejectedBy || ""}
                                    </span>
                                    <span
                                      style={{
                                        fontSize: 12,
                                        color: "#888",
                                        fontFamily: fontFamily,
                                      }}
                                    >
                                      {popoverRow?.rejectedDate
                                        ? formatDate(popoverRow.rejectedDate)
                                        : ""}
                                    </span>
                                  </div>
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: 13,
                                      color: "#444",
                                      fontFamily: fontFamily,
                                      lineHeight: 1.5,
                                    }}
                                  >
                                    {notes}
                                  </p>
                                </div>
                              </Popover>
                            </div>
                          ) : column.field === "functions" ? (
                            <div style={{ display: "flex", alignItems: "flex-end" }}>
                              <div style={{ marginRight: "auto" }}></div>
                              <DeleteButton
                                onClick={() => {
                                  setIsPopupOpen(true);
                                  setSelectDeletedItem(row.fileImportId);
                                }}
                              />
                            </div>
                          ) : column.headerName === "REJECTED DATE" ? (
                            formatDate(row[column.field])
                          ) : column.field === "businessUnit" ? (
                            formatBusinessUnitLabel ? (
                              formatBusinessUnitLabel(row)
                            ) : (
                              row[column.field]
                            )
                          ) : column.field === "fileName" ? (
                            <span
                              style={{
                                color: "#101828",
                                textTransform: "uppercase",
                                fontWeight: 400,
                              }}
                            >
                              {row[column.field]}
                            </span>
                          ) : (
                            row[column.field]
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>

        <DeleteModal
          open={isPopupOpen}
          isDeleting={isDeleting}
          onClose={() => setIsPopupOpen(false)}
          onDelete={handleDelete}
        />
      </div>
      <ConditionalPagination
        itemCount={rows.filter((item) => item.rejectedBy !== null).length}
        itemsPerPage={dynamicRowsPerPage}
        threshold={dynamicRowsPerPage}
        paginationProps={{
          page: currentPage,
          onChange: handlePageChange,
          style: paginationstyle,
          sx: paginationStyles,
          hidePrevButton: false,
          hideNextButton: false,
          showFirstButton: true,
          showLastButton: true,
        }}
      />
    </>
  );
}
